import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  AdminGridDirective,
  AdminGridConfig,
  AdminGridCallbackEvent,
} from '../../shared/admin-grid.directive';
import { GridSaveFactoryService } from '../../../core/grid/services/grid-save-factory.service';
import { GlobalService } from '../../../global/services/global.service';

/**
 * Angular 12 migration of admin.change-log-job-run-details.
 * Grid: loadGridJson?action_id=32966&grid_id=6025 (from changeLogJobRunDetails.js).
 * No filter bar — original AngularJS template renders only the grid.
 * Switch toggles on the CHANGE_LOG_RUN_ENABLED column route through
 * GridSaveFactoryService.saveSwitch → registered 'toggle-change-log' handler
 * (saveJsonObject?action_id=32967).
 */
@Component({
    selector: 'gtw-change-log-job-run-details',
    templateUrl: './change-log-job-run-details.component.html',
    styleUrls: ['./change-log-job-run-details.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ChangeLogJobRunDetailsComponent implements OnInit, OnDestroy {
  @ViewChild(AdminGridDirective) adminGrid!: AdminGridDirective;

  gridConfig!: AdminGridConfig;

  private readonly ACTION_ID = 32966;
  private readonly GRID_ID = '6025';
  private readonly destroy$ = new Subject<void>();

  constructor(
    private cdr: ChangeDetectorRef,
    private gridSaveFactory: GridSaveFactoryService,
    private globalService: GlobalService,
  ) {}

  ngOnInit(): void {
    this.gridConfig = {
      actionId: this.ACTION_ID,
      gridId: this.GRID_ID,
      autoLoad: true,
      cacheKey: 'admin/change-log-job-run-details',
    };

    // When a toggle save is rejected (e.g. no access to the client's
    // resources), the optimistic checkbox change is left in the grid. Reload
    // the true server state so the UI stays consistent with the access rules.
    this.gridSaveFactory.gridSaveError$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.adminGrid?.clearCache();
        this.adminGrid?.refresh();
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  // ---------------------------------------------------------------------------
  // Grid events
  // ---------------------------------------------------------------------------

  onGridCallback(event: AdminGridCallbackEvent): void {
    if (event?.type === 'input') {
      const globalParams = this.globalService.global?.globalParams || {};
      this.gridSaveFactory.saveSwitch(event.callName, event.data, globalParams);
    }
  }
}
